<template>
  <v-container fluid="" class="ma-0 pa-0">
    <v-card outlined="" flat="" v-if="loading" class="mt-4">
      <v-skeleton-loader
        ref="skeleton"
        :boilerplate="true"
        type="card-heading, list-item-three-line"
      ></v-skeleton-loader>
    </v-card>
    <v-card
      width="100%"
      flat=""
      outlined=""
      class="mt-4"
      v-for="item in subscription.items"
      :key="item.id"
    >
      <v-skeleton-loader
        width="100%"
        max-width="550px"
        type="card-heading, list-item,list-item,list-item,list-item"
        :loading="loading"
      >
        <v-card-title> <b>Plan Details</b> </v-card-title>
        <div class="pl-4 pr-4">
          <p class="body-1">
            <span class="mr-2"><b>Plan:</b></span>
            {{
              item.price && item.price.product ? item.price.product.name : ""
            }}
            <v-btn
              v-if="!loading && isUpgradable(item) && !hide"
              class="mt-a mb-a ml-3"
              rounded=""
              :to="{ name: 'billing-plans' }"
              depressed=""
              dark=""
              color="blue"
              x-small=""
              >Upgrade</v-btn
            >
          </p>
          <p class="body-1">
            <span class="mr-2"><b>Billing Period:</b></span>
            {{
              new Date(subscription.current_period_start * 1000).toDateString()
            }}
            -
            {{
              new Date(subscription.current_period_end * 1000).toDateString()
            }}
          </p>
        </div>
      </v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<script>
import services from "@/services";
export default {
  props: ["subscriptionid"],
  data: () => ({
    loading: true,
    subscription: {
      items: []
    }
  }),
  methods: {
    isUpgradable(item) {
      return item && item.metadata ? item.metadata.primary === "true" : false;
    },
    async getSubscription(id) {
      const x = await services.billing.subscriptions.getByID({
        subscription: id
      });
      return x;
    }
  },
  computed: {
    hide() {
      return (
        this.$store.getters["enterprise"] === "unloaded" ||
        this.$store.getters["enterprise"] === true
      );
    }
  },
  async mounted() {
    this.loading = true;
    const results = await this.getSubscription(this.subscriptionid);
    console.log("SUB", results);
    this.subscription = results;
    this.loading = false;
  }
};
</script>

<style></style>
